/**
 * Build a URL with query parameters.
 *
 * @param path - Base path (e.g. `projects/${id}/characters`)
 * @param params - Key-value query params (undefined values are skipped)
 * @param rawQueryStrings - Pre-formatted query strings to append (e.g. tags query `tags[]=1&tags[]=2`)
 */
export function buildUrl(
    path: string,
    params?: Record<string, string | number | boolean | undefined>,
    ...rawQueryStrings: (string | undefined | null)[]
): string {
    const searchParams = new URLSearchParams();

    if (params) {
        for (const [key, value] of Object.entries(params)) {
            if (value !== undefined && value !== null && value !== '') {
                searchParams.set(key, String(value));
            }
        }
    }

    const parts: string[] = [];
    const paramStr = searchParams.toString();
    if (paramStr) parts.push(paramStr);

    for (const raw of rawQueryStrings) {
        if (raw) parts.push(raw);
    }

    const qs = parts.join('&');
    return qs ? `${path}?${qs}` : path;
}
